import { observer } from 'mobx-react';
import { useStore } from '../../../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button, Card, Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../../../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { TextField } from '@mui/material';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
// import Grid from "@mui/material/Grid/Grid";
import Etherimage from "../../../Main/image/2089411.png";
import Dimage from "../../../Main/image/Icon256.png";
import MiningImage from "../../../Main/image/MiningIcon.png";

// import { useEffect } from "react";
// import UserImage from "../Main/image/User.png";
// import EtherImage from "../Main/image/2089411.png"
// import StandImage from "../Main/image/Icon256.png"
// import { faSquarePlus } from '@fortawesome/free-solid-svg-icons';
// import { faSquareMinus } from '@fortawesome/free-solid-svg-icons';
import { toJS } from 'mobx';
import Slider from 'react-slick';
// import "../../../../../node_modules/slick-carousel/slick/slick.css"
// import "../../../../../node_modules/slick-carousel/slick/slick-theme.css"
import styled from "@emotion/styled";
import ProductPurchaseCard from './ProductPurchaseCard';












function MarketProductPurchase() {
  const { loginStore } = useStore();
  const { SaleStore } = useStore();
  // const { CoinStore } = useStore();


  // const navigate = useNavigate();

  const useStyles = makeStyles((theme) => ({
    //Dialog
    Dialog: {
      width: '80rem',
      height: "40rem",
      minHeight: "35rem",
      // minHeight: "auto",
      // backgroundColor:"#212121"

    },
    DialogMobile: {
      height: 'auto',
      width: '100%',
      minWidth: "320px",
      padding: '0'
    },
    //CategoryImage
    CategoryImage: {
      whiteSpace: "nowrap",
      objectFit: "cover",
      width: '10rem',
      height: "5rem"
    },
    //CategoryImage
    BrandImage: {
      whiteSpace: "nowrap",
      objectFit: "cover",
      width: '12rem',
      height: "12rem"
    },
    //BrandiamgeSlide
    BrandiamgeSlide: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    },
    DimagePC: {
      width: '2rem',
      height: "2rem"
    },
    DimageMobile: {
      width: '40%',
      height: "40%"
    },
    EtherimagePC: {
      width: '2rem',
      height: "2rem"
    },
    EtherimageMobile: {
      width: '40%',
      height: "40%"
    }
  }));


  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");




  const WhiteTextTypography = withStyles({
    root: {
      color: "#FFFFFF",
      fontSize: "1.5rem"
    }
  })(Typography);

  const CategoryTypography = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '1.5rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1.2rem',
      }
  })(Typography);


  const BrandTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.8rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1.5rem',
      }
  })(Typography);

  const MobileTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '1rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
      }
  })(Typography);

  const PCTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.8rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1.5rem',
      }
  })(Typography);



  const isCloverMarketProductDialogOpen = loginStore?.isCloverMarketProductDialogOpen;
  // let isUserMarketPage = SaleStore?.isUserMarketPage;

  let User_Product_item = toJS(SaleStore?.User_Product_item);
  let User_Brand_name = `[${SaleStore?.User_Brand_name}]`;
  let User_market_exchange = toJS(SaleStore?.user_market_exchange);



  const StyledSlider = styled(Slider)`
height: 100%;
width: 100%;
position: relative;
.slick-prev::before,
.slick-next::before {
  opacity: 0;
  display: none;
}`;

  const Pre = styled.div`
width: 30px;
height: 30px;
position: absolute;
// left: -4%;
z-index: 3;
`;

  const NextTo = styled.div`
width: 30px;
height: 30px;
position: absolute;
// right: -4%;
z-index: 3;
`;

  const settings = {
    dots: true,
    // fade: true,
    infinite: true,
    autoplay: true,
    pauseOnHover: true,
    // centerMode: true,
    // centerPadding: '33rem',
    // variableWidth: true,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    nextArrow: (
      <NextTo />
    ),
    prevArrow: (
      <Pre />
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // centerMode: true,
          // centerPadding: '22rem',
          // infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // centerPadding: '3rem',
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // centerPadding: '1rem',
        }
      }
    ]
  };


  return (
    <div>
      <Dialog fullScreen={isMobile ? true : false} classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isCloverMarketProductDialogOpen} onClose={loginStore.setDialogClose()}>
        <Box sx={isMobile ? { bgcolor: "#212121", width: "100%", height: "100%" } : { bgcolor: "#212121", width: "80rem", height: "80rem" }}>
          <Box sx={isMobile ?
            { display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600px', minWidth: '320px', height: '60px', }
            :
            { display: 'flex', bgcolor: 'black', width: '80rem', height: '50px', }}>
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
              <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
                <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                <WhiteTextTypography >Product</WhiteTextTypography>
              </Grid>
              <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("CloverMarketProductFalse") }} />
              </Grid>
            </Grid>
          </Box>

          {isMobile ?

            <DialogContent sx={{ padding: 0, margin: 0 }} >



              {User_Product_item.Index !== -1 &&
                <div style={{ width: "100%", maxWidth: "1250px", backgroundColor: "#212121" }}>
                  <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction="row" justifyContent="center" alignItems="center"
                    marginBottom="0.5rem"
                  >
                    <Box sx={{ width: "70%", py: "0.5rem" }} >
                      <ProductPurchaseCard key={User_Product_item.Index} item={User_Product_item} />
                    </Box>
                  </Grid>

                  <Box sx={{ border: 1, borderColor: "white", m: 1, p: 1, marginX: "1rem", paddingY: "0.5rem" }}>

                    <Box
                      sx={{ backgroundColor: "#212121", paddingBottom: "0.5rem", py: 1, borderBottom: 1, borderBottomColor: "white" }} >
                      <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction="column" justifyContent="center" alignItems="center" gap={1} >
                        <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} justifyContent="center"
                          sx={{ m: 0, p: 0 }}
                        >
                          <MobileTypographyMobile>
                            {/* {User_Brand_name} */}
                            {User_Product_item?.goods_name}

                          </MobileTypographyMobile>
                        </Grid>
                        <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} justifyContent="center"
                          sx={{ m: 0, p: 0 }}
                        >
                          <MobileTypographyMobile>
                          {User_Product_item?.description}
                          
                          </MobileTypographyMobile>
                        </Grid>
                      </Grid>
                  </Box>
                    {/* <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction="row" justifyContent="center" alignItems="center" gap={1}>
                      <MobileTypographyMobile>
                        {User_Product_item?.description}
                      </MobileTypographyMobile>
                    </Grid> */}

                  <Box sx={{ py: 2, borderBottom: 1, borderBottomColor: "white" }}>
                    <Box sx={{ backgroundColor: "#212121", paddingBottom: "0.15rem" }} >
                      <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction="row" justifyContent="flex-start" alignItems="center" >
                        <Grid container item xs={2} sm={2} md={2} lg={2} xl={2}
                          justifyContent="center"
                        >
                          <img src={MiningImage} className={isMobile ? classes.DimageMobile : classes.DimagePC} />
                        </Grid>
                        <Grid item xs={9} sm={9} md={9} lg={9} xl={9}
                          sx={{ m: 0, p: 0 }}
                        >
                          <CategoryTypography>
                            {User_market_exchange?.MarketPriceExchange}
                          </CategoryTypography>
                        </Grid>
                      </Grid>
                    </Box>

                    {/* <Box
                        sx={{ backgroundColor: "#212121", paddingBottom: "0.25rem" }}
                      >
                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction="row" justifyContent="flex-start" alignItems="center" >
                          <Grid container item xs={2} sm={2} md={2} lg={2} xl={2}
                            justifyContent="center"
                          >
                            <img src={Etherimage} className={isMobile ? classes.EtherimageMobile : classes.EtherimagePC} />
                          </Grid>
                          <Grid item xs={9} sm={9} md={9} lg={9} xl={9}
                            sx={{ m: 0, p: 0 }}
                          >
                            <CategoryTypography>
                              {User_market_exchange?.commision}
                            </CategoryTypography>

                          </Grid>
                        </Grid>
                      </Box> */}
                  </Box>

                  <Box
                    sx={{ py: "1.5rem" }}
                  >
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction="row" justifyContent="space-around" alignItems="center" gap={1}
                    >
                      <Button
                        sx={{ width: '40%', padding: 1, margin: 0, color: 'white', fontWeight: 'bold', fontSize: '1rem', border: 2, bgcolor: "#1E90FF" }}
                        onClick={() => { SaleStore?.getMarketProductBuy(User_market_exchange, User_market_exchange?.MarketPriceExchange) }}
                      >
                        구매
                      </Button>
                      <Button
                        sx={{ width: '40%', padding: 1, margin: 0, color: 'white', fontWeight: 'bold', fontSize: '1rem', border: 2, bgcolor: "red" }}
                        onClick={(e) => { loginStore.setDialogClose("CloverMarketProductFalse") }}

                      >
                        취소
                      </Button>

                    </Grid>
                  </Box>
                </Box>
                </div>
              }
        </DialogContent>
        :


        <DialogContent sx={{ padding: 0, margin: 0 }} >

          <div
            style={{ width: "100%", maxWidth: "80rem", backgroundColor: "#212121", margin: 0, padding: 0, paddingTop: "2rem", marginRight: 0 }}
          >
            <Grid
              container item xs={12} sm={12} md={12} lg={12} xl={12}
              direction="column"
              sx={{ margin: 0, padding: 0 }}
            >
              <Grid
                item xs={10} sm={10} md={10} lg={10} xl={10}
                sx={{ margin: 0, padding: 0 }}
              >
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12}
                  direction="row"
                  sx={{ margin: 0, padding: 0 }}
                >
                  <Grid container item xs={5} sm={5} md={5} lg={5} xl={5}
                    justifyContent="center"
                    sx={{ m: 0, p: 0 }}
                  // bgcolor="red" 
                  >
                    <Box sx={{ bgcolor: "white", p: 5, width: 350, height: 350, border: 2, borderBlockColor: "#B6B8B1", boxShadow: 5 }}>
                      <img style={{ width: "100%", height: "100%" }} src={User_Product_item?.image} />
                    </Box>
                  </Grid>
                  <Grid container item xs={6} sm={6} md={6} lg={6} xl={6}
                    justifyContent="flex-start"

                    sx={{ m: 0, p: 0 }}
                  // bgcolor= "brown"
                  >
                    <Box sx={{ border: 1, width: "40rem", height: "27rem", borderColor: "white", borderRadius: 3 }}>
                      <Grid container
                        item xs={12} sm={12} md={12} lg={12} xl={12}
                        direction="column"
                        sx={{ margin: 0, py: "2.5rem", paddingX: 0.5 }}
                        justifyContent="space-around"
                        spacing={1}
                      >
                        <Grid container
                          item xs={6} sm={6} md={6} lg={6} xl={6}
                          sx={{ borderBottom: 2, borderBlockColor: "#B6B8B1", width: "38rem", py: "2rem" }}
                          direction= "column"
                          justifyContent="center"
                          alignItems="center"
                          gap={2}
                        >
                          <PCTypographyMobile>
                            {/* {User_Brand_name} */}
                            {User_Product_item?.goods_name}
                          </PCTypographyMobile>
                          <PCTypographyMobile>
                            {User_Product_item?.description}
                            {/* {User_Brand_name} */}
                          </PCTypographyMobile>
                        </Grid>
                        <Grid container
                          item xs={6} sm={6} md={6} lg={6} xl={6}
                          sx={{ borderBottom: 2, borderBlockColor: "#B6B8B1", width: "38rem", py: "2rem" }}
                          direction="column"
                          justifyContent="center"
                          alignItems="flex-start"
                          gap={2}
                        >
                          <Grid container
                            sx={{ paddingTop: "2rem" }}
                            item xs={12} sm={12} md={12} lg={12} xl={12}
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            gap={1}
                          >
                            <img className={classes.DimagePC} src={MiningImage} alt='Dimage' />
                            <BrandTypographyMobile>
                              {User_market_exchange?.MarketPriceExchange}
                            </BrandTypographyMobile>
                          </Grid>
                          {/* <Grid container
                                // sx={{bgcolor: "brown"}}
                                item xs={12} sm={12} md={12} lg={12} xl={12}
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                gap={1}
                              >
                                <img className={classes.EtherimagePC}
                                  src={Etherimage} />
                                <BrandTypographyMobile>
                                  {User_market_exchange?.commision}
                                </BrandTypographyMobile>
                              </Grid> */}
                        </Grid>

                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}
                          sx={{ p: 0, m: 0 }}
                        >
                          <Grid container
                            item xs={11} sm={11} md={11} lg={11} xl={11}
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ p: 0, m: 0, paddingTop: 4 }}
                            gap={5}
                          >
                            <Button
                              sx={{ width: '30%', padding: 2, margin: 0, color: 'white', fontWeight: 'bold', fontSize: '1rem', border: 2, bgcolor: "#1E90FF" }}
                              onClick={() => { SaleStore?.getMarketProductBuy(User_market_exchange, User_market_exchange?.MarketPriceExchange) }}
                            >
                              구매
                            </Button>
                            <Button
                              sx={{ width: '30%', padding: 2, margin: 0, color: 'white', fontWeight: 'bold', fontSize: '1rem', border: 2, bgcolor: "red" }}
                              onClick={(e) => { loginStore.setDialogClose("CloverMarketProductFalse") }}
                            >
                              취소
                            </Button>

                          </Grid>
                        </Grid>

                      </Grid>

                    </Box>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </div>

        </DialogContent>
          }



      </Box>
    </Dialog>
    </div >
  );
};

export default observer(MarketProductPurchase);


